import type { FC } from 'react';
import { Skeleton } from '@chakra-ui/react';
import type { SkeletonProps } from '@chakra-ui/react';

export const AccountTwoColumnSkeleton: FC<SkeletonProps> = (props) => (
    <div
        className="flex items-center justify-center bg-white base:flex-col md:flex-row"
        data-testid="account-two-column-skeleton"
    >
        <Skeleton
            {...props}
            margin={{
                base: '2rem 0 2rem 0',
                sm: 8,
                lg: '4rem 2rem 4rem 2rem',
                xl: 16,
            }}
            height={{
                base: '366px',
                md: '406px',
            }}
            width={{
                base: '100vw',
                sm: '448px',
                md: '100%',
                lg: '448px',
                xl: '640px',
            }}
            rounded="none"
        />
        <Skeleton
            {...props}
            margin={{
                base: '4rem 0 4rem 0',
                sm: '4rem 2rem 4rem 2rem',
                lg: '4rem 2.5rem 4rem 2rem',
                xl: 16,
            }}
            height={{
                base: '544px',
                sm: '504px',
                md: '406px',
                xl: '504px',
            }}
            width={{
                base: '100vw',
                sm: '448px',
                md: '100%',
                lg: '448px',
            }}
            rounded="none"
        />
    </div>
);
